import { useQuery } from "@tanstack/react-query";
import { adminApiClient } from "../../lib/adminApiClient";
import { queryKeys } from "../../lib/queryClient";
import { DisputeStatusBadge } from "../../components/StatusBadge";
import { ErrorBanner, LoadingState } from "../../components/States";
import { formatDateTime } from "../../lib/format";

export function AdminDisputesPage() {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: queryKeys.adminDisputes,
    queryFn: () => adminApiClient.listDisputes({ limit: 50 }),
  });

  return (
    <div className="stack">
      <h1>Disputes</h1>

      {isLoading && <LoadingState label="Loading disputes…" />}
      {isError && <ErrorBanner error={error} onRetry={() => void refetch()} />}

      {data && (
        <div style={{ overflowX: "auto" }}>
          <table className="admin-table">
            <thead>
              <tr>
                <th>Category</th>
                <th>Claim</th>
                <th>Status</th>
                <th>Opened</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((d) => (
                <tr key={d.id}>
                  <td>{d.category}</td>
                  <td style={{ maxWidth: 360 }}>{d.claim}</td>
                  <td>
                    <DisputeStatusBadge status={d.status} />
                  </td>
                  <td>{formatDateTime(d.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {data.items.length === 0 && <p className="muted">No disputes found.</p>}
        </div>
      )}
    </div>
  );
}
